module.exports = __webpack_public_path__ + "fonts/ttnorms-medium-webfont.6be51cde.woff2";